import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Heading, VStack } from '@gluestack-ui/themed';

const EssayTaskSidebar = ({ task, children, ...props }) => {
  const { t } = useTranslation();

  if (!task) return null;

  return (
    <Card testID="essay-task-sidebar" {...props}>
      <VStack space="lg">
        <Heading size="lg">{t('student.module.task-sidebar.title')}</Heading>
        {children}
      </VStack>
    </Card>
  );
};

export default EssayTaskSidebar;
